<template>
  <section>
    <v-tooltip bottom>
      <v-btn
        icon
        slot="activator"
        color="#00857D"
        outline
        @click="
          () => {
            this.dialog = this.dialog ? false : true;
          }
        "
      >
        <v-icon>today</v-icon>
      </v-btn>
      <span>Ver detalle</span>
    </v-tooltip>
    <v-dialog v-model="dialog" persistent width="900">
      <v-card>
        <!-- Cabecera del formulario -->
        <v-toolbar color="#00857D" dark>
          <v-icon>today</v-icon>
          <b>VER DETALLE DEL DÍA</b>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="py-3 px-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-card                
                class="text-xs-center font-weight-bold blue--text "
                style="font-size:1.5em"
                elevation="0"               
              >
                {{
                  `${persona.ap_paterno} ${persona.ap_materno} ${persona.nombres}`
                }}
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card dark class="text-xs-center titulo-fecha" >
                <v-tooltip bottom>
                  <v-btn
                    slot="activator"
                    outlined
                    icon
                    @click="actualizaFecha(-1)"
                  >
                    <v-icon large color="blue">chevron_left</v-icon>
                  </v-btn>
                  <span>Anterior</span>
                </v-tooltip>
                {{ $moment(fecha_actual).format("DD/MM/YYYY") }}
                <v-tooltip bottom>
                  <v-btn
                    slot="activator"
                    outlined
                    icon
                    @click="actualizaFecha(1)"
                  >
                    <v-icon large color="blue">chevron_right</v-icon>
                  </v-btn>
                  <span>Siguiente</span>
                </v-tooltip>
              </v-card>
              <div v-if="lista_detalle_dia.length > 0">
                <v-card
                  v-for="detalle in lista_detalle_dia"
                  :key="detalle.hora_marcada"
                  class="px-1"
                >
                  <v-layout row wrap>
                    <v-flex xs4 md2>
                      <CuadroDetalle
                        :detalle="detalle.horario"
                        titulo="HORARIO"
                        color="AliceBlue"
                        ruta_icono="static/images/reloj.png"
                      />
                    </v-flex>
               
                    <v-flex xs4 md2>
                      <CuadroDetalle
                        :detalle="detalle.tolerancia"
                        titulo="TOLERANCIA"
                        color="AliceBlue"
                        ruta_icono="static/images/reloj.png"
                      />
                    </v-flex>
                    <v-flex xs4 md2>
                      <CuadroDetalle
                        :detalle="detalle.hora_marcada"
                        titulo="MARCADO"
                        color="AliceBlue"
                        ruta_icono="static/images/reloj.png"
                      />
                    </v-flex>
                    <v-flex xs4 md2>
                      <CuadroDetalle
                        :detalle="detalle.atraso"
                        titulo="ATRASO"
                        color="#80CBC4"
                        ruta_icono="static/images/reloj.png"
                      />
                    </v-flex>
                    <v-flex md4 class="text-xs-center">
                      <b>OBSERVACIÓN: </b
                      >{{
                        detalle.bandera_marcado ? detalle.bandera_marcado : "-"
                      }}
                      <br />
                      <b>DETALLE: </b>{{ detalle.descripcion_caso }}
                    </v-flex>

                    <!-- <v-flex xs12 md6>
                      <b>HORARIO: </b>{{ detalle.horario }}
                    </v-flex>
                    
                    <v-flex xs12 md6>
                      <b>HORA MARCADA: </b>{{ detalle.hora_marcada }}
                    </v-flex>
                    <v-flex xs12 md6>
                      <b>ATRASO: </b>{{ detalle.atraso }}
                    </v-flex>
                    <v-flex xs12 md6>
                      <b>OBSERVACIÓN: </b>{{ detalle.bandera_marcado }}
                    </v-flex>
                    <v-flex xs12 md6>
                      <b>DETALLE: </b>{{ detalle.descripcion_caso }}
                    </v-flex> -->
                  </v-layout>
                  <v-divider></v-divider>

                </v-card>
              </div>
              <div v-else class="text-xs-center">
                <h4>NO EXISTE DATOS</h4>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import CuadroDetalle from "./CuadroDetalle";
export default {
  // Variables iniciales
  components: { CuadroDetalle },
  props: ["fecha", "persona"],
  data() {
    return {
      form: {},
      dialog: false,
      loading: false,
      lista_detalle_dia: [],
      fecha_actual: this.fecha
    };
  },
  async created() {
    await this.cargarDetalleDia(this.fecha);
  },
  async mounted() {},
  methods: {
    // Metodo para actualizar la fecha
    async actualizaFecha(valor) {
      this.fecha_actual = this.$moment(this.fecha_actual)
        .add(valor, "day")
        .format("YYYY-MM-DD");
      await this.cargarDetalleDia();
    },
    // Metodo para cargar detalle del dia
    async cargarDetalleDia(fecha) {
      try {
        let res = await this.$service.graphql({
          query: ` 
            query{
              runQuery(consulta:"SELECT i.nro_item, concat(p.nro_doc,' ',p.nro_complemento) AS carnet    ,concat(p.ap_paterno,' ',p.ap_materno,' ',p.nombres) AS nombres ,u.nombre_unidad ,(SELECT planilla.fn_obtiene_vice_despacho_de_persona(u.id)) AS unidad_superior   ,fecha_marcado ,(CASE WHEN (tipo_marcado = 'HN' AND tipo_horario= 'E') THEN 5 WHEN (tipo_marcado = 'CP' AND (control.fn_tipo_permiso(ca.id_papeleta) = 8)) THEN (control.fn_obtiene_tolerancia(control.fn_tipo_permiso(ca.id_papeleta))) ELSE 0 END) AS tolerancia ,secuencia, horario, hora_marcada ,atraso,bandera_marcado,descripcion_caso  FROM planilla.control_asistencia ca, persona.persona p, movilidad.movilidad m, movilidad.unidad u, movilidad.item i  WHERE ca.id_persona = p.id AND m.id_persona = p.id AND m.id_estado in (1, 53) AND m.id_tipo_justificacion NOT IN (5,6,10) AND m.id_unidad = u.id  AND i.id = m.id_item  AND fecha_marcado BETWEEN  '${this.fecha_actual}' AND '${this.fecha_actual} 'AND ca.id_persona =  ${this.persona.id_persona}  AND ca.mostrar IS NULL ORDER BY fecha_marcado,horario,hora_marcada::INTERVAL,secuencia asc"){
                  respuesta
                }
              }
            `
        });
        this.lista_detalle_dia = res.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },

    close() {
      this.loading = false;
      this.dialog = false;
      this.url = "";
    },
    openNewWindow() {
      window.open(this.url);
    }
  }
};
</script>
<style lang="scss" scoped>
.titulo-fecha {
  background: rgba(255, 255, 255, 0.945);
  color: #2196f3;
  font-size: 1.5em;
  font-weight: bold;
  font-family: Helvetica;
  text-align: center;
  // text-shadow: 0 1px 0 rgb(204, 204, 204), 0 2px 0 #c9c9c9, 0 3px 0 #bbb, 0 3px 0 #b9b9b9,
  //   0 1px 0 #aaa, 0 6px 1px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1),
  //   0 1px 3px rgba(0, 0, 0, 0.3), 0 3px 5px rgba(0, 0, 0, 0.2),
  //   0 5px 10px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.2),
  //   0 20px 20px rgba(0, 0, 0, 0.15);
}
.texto-cuadro {
  background: rgba(255, 255, 255, 0.5);
  color: #2196f3;
  font-size: 1.5em;
  font-weight: bold;
  font-family: Helvetica;
  text-align: center;
  // text-shadow: 0 1px 0 rgb(204, 204, 204), 0 2px 0 #c9c9c9, 0 3px 0 #bbb, 0 3px 0 #b9b9b9,
  //   0 1px 0 #aaa, 0 6px 1px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1),
  //   0 1px 3px rgba(0, 0, 0, 0.3), 0 3px 5px rgba(0, 0, 0, 0.2),
  //   0 5px 10px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.2),
  //   0 20px 20px rgba(0, 0, 0, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/components/VerDetalleDia.vue